import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { calculateDetailAmount, SALES_ORDER_DETAIL_AMOUNT_MAPPING } from "src/utils/calculation/calculationUtils";
import { SAL1010_R01DetailDto } from "../Dto_SAL1010_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

interface UseSAL1010_R01CellChangeProps {
	SAL1010_R01DetailList: SAL1010_R01DetailDto[];
	originalSAL1010_R01DetailList: SAL1010_R01DetailDto[];
	updateSAL1010_R01DetailList: (index: number, data: SAL1010_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<SAL1010_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
	customCd?: string;
}

export function useSAL1010_R01CellChange({
	SAL1010_R01DetailList,
	originalSAL1010_R01DetailList,
	updateSAL1010_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
	customCd,
}: UseSAL1010_R01CellChangeProps) {
	const { searchExactItemCode } = useCodeSearch({});
	const SAL1010R01Config = createModuleConfig.SAL1010();

	 // PROGRAM 공통코드에서 ITEM_POPUP_SEARCH의 ref01 값으로 필터 사용 여부 결정
	const { programList } = useCommonCodeStore();
	const useCustomCdFilter =
		programList.find(c => c.minorCd === 'ITEM_POPUP_SEARCH')?.ref01 === 'Y';

	const fieldConfigWithSearch = {
		...SAL1010R01Config.fieldConfig,
		codeSearchFields: {
			...SAL1010R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...SAL1010R01Config.fieldConfig.codeSearchFields!.itemCd,
				searchFilters: () =>
					useCustomCdFilter && customCd?.trim() ? { customCd: customCd.trim() } : undefined,
				searchFunction: searchExactItemCode,
			},
		},
	};

	const calculateAmount = (data: SAL1010_R01DetailDto): SAL1010_R01DetailDto =>
		calculateDetailAmount(data, SALES_ORDER_DETAIL_AMOUNT_MAPPING);

	const detailTableHandlers = useCommonDetailTableHandlers<SAL1010_R01DetailDto>({
		detailList: SAL1010_R01DetailList,
		updateDetailList: updateSAL1010_R01DetailList,
		originalDetailList: originalSAL1010_R01DetailList,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: SAL1010R01Config.codeSearchConfig,
		calculateAmount,
	});

	return {
		...detailTableHandlers,
		calculateAmount,
	};
}
